/**
 * @fileoverview A subheader compoment for part of a page.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */
import * as styles from '/src/com/yext/listingslaunchstorm/js/components/styles/subheader.module.scss';

/**
 * A subheader compoment for part of a page.
 * @param {{
 *  mainText: string,
 *  extraText: (string | undefined)
 * }} props
 * @return {React.ReactNode}
*/
export const SubHeader = ({mainText, extraText}) => {
  return (
    <div className={styles.subHeader}>
      {mainText && <span className={styles.mainText}>{mainText}</span>}
      {extraText && <span className={styles.extraText}>{extraText}</span>}
    </div>
  );
};
